import InvoicesForPaymentDatagrid from 'src/components/DatagridEntity/InvoicesForPaymentDatagrid';

const InvoicesPaymentPage = () => (<InvoicesForPaymentDatagrid />);
export default InvoicesPaymentPage;
